// https://github.com/Leaflet/Leaflet.markercluster#options
export const clusterOptions = {
    showCoverageOnHover: false,
    singleMarkerMode: false,
};

// https://github.com/yairEO/tagify#suggestions-list
export function getTagifyOptions(tags) {
    return {
        whitelist: tags,
        enforceWhitelist: true,
        dropdown: {
            maxItems: 20,
            position: 'input',
            enabled: 0,
        },
    };
}

// https://github.com/Norkart/Leaflet-MiniMap#available-options
export const minimapOptions = {
    zoomLevelFixed: 6,
    toggleDisplay: true,
    autoToggleDisplay: true,
    minimized: true,
    aimingRectOptions: {
        color: '#fc0',
        weight: 1,
        fill: '#fc0',
    },
};
